import { render, staticRenderFns } from "./TimelineVis.vue?vue&type=template&id=45d94c52"
import script from "./TimelineVis.vue?vue&type=script&lang=js"
export * from "./TimelineVis.vue?vue&type=script&lang=js"
import style0 from "./TimelineVis.vue?vue&type=style&index=0&id=45d94c52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports